import store from "@/vue/planning/store/store"
import getWiypData from "@/vue/planning/computed/getWiypData"
import type { PrestationData, Variant } from "@/types"

export function variantHasWiypPrice(variant: Variant): boolean {
	if (store.state.packCode === "HS") return true

	const wiypData = getWiypData.value(variant.prestId)
	if (!wiypData?.wiypPrices) return false

	return wiypData.wiypPrices.some(
		(w) => w.prestId === variant.prestIdSource && w.sellingPriceWiyp > 0
	)
}

export function prestationHasWiypPrice(prestation: PrestationData): boolean {
	if (!prestation || Object.keys(prestation).length === 0) return true
	if (store.state.packCode === "HS") return true
	if (!store.state.packageId) return false

	const variants = prestation.variants || []
	if (variants.length === 0) return false

	return variants.some(variantHasWiypPrice)
}
